import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=b8b5e06a"
import script from "./dictionary.vue?vue&type=script&lang=js"
export * from "./dictionary.vue?vue&type=script&lang=js"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=b8b5e06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports